import { FilterCondition } from "../schema/filter.js";
import { ParentItem } from "../schema/item.js";

export const filterColumn = (
  tableData: ParentItem[],
  condition: FilterCondition
): ParentItem[] => {
  const newTableData = [] as ParentItem[];
  tableData.forEach((parentItem: ParentItem) => {
    let hideFlag = false;
    for (const [key, value] of Object.entries(condition)) {
      if (key == "check") {
        hideFlag ||= checkColumnHideFlag(parentItem, value) && value !== "all";
      } else {
        hideFlag ||= !value.includes(parentItem[key]) && value !== "all";
      }
    }
    if (!hideFlag) {
      newTableData.push(parentItem);
    }
  });
  return newTableData;

  // スクロール移動の処理
  // const viewportHeight =
  //   window.innerHeight || document.documentElement.clientHeight;

  // if (dataTableElement.getBoundingClientRect().bottom < viewportHeight - 200) {
  //   window.scrollTo({
  //     top:
  //       dataTableElement.getBoundingClientRect().bottom - viewportHeight - 200,
  //   });
  // }
};

const checkColumnHideFlag = (parentItem: ParentItem, values) => {
  const hideFlagComp = !parentItem.childCheckState.comp;
  const [now, all] = [
    parentItem.childCheckState.owned,
    parentItem.childCheckState.total,
  ];
  const hideFlag1Left = all - now !== 1;
  const hideFlag2Left = all - now !== 2;
  const hideFlag3Left = all - now !== 3;
  const hideFlag4Left = all - now !== 4;
  const hideFlagDontHave = !hideFlagComp;
  const hideFlagQR = !parentItem.children.some((item) => item.qr === undefined);
  const hideFlagQRexist = parentItem.children.every(
    (item) => item.qr === undefined
  );

  let hideFlag = false;
  if (values.includes("no QR") || values.includes("exist QR")) {
    if (
      values.includes("COMP") ||
      values.includes("1 left") ||
      values.includes("2 left") ||
      values.includes("3 left") ||
      values.includes("4 left") ||
      values.includes("don't have")
    ) {
      hideFlag = true;
      if (values.includes("COMP")) hideFlag &&= hideFlagComp;
      if (values.includes("1 left")) hideFlag &&= hideFlag1Left;
      if (values.includes("2 left")) hideFlag &&= hideFlag2Left;
      if (values.includes("3 left")) hideFlag &&= hideFlag3Left;
      if (values.includes("4 left")) hideFlag &&= hideFlag4Left;
      if (values.includes("don't have")) hideFlag &&= hideFlagDontHave;
      if (values.includes("no QR")) hideFlag ||= hideFlagQR;
      if (values.includes("exist QR")) hideFlag ||= hideFlagQRexist;
    } else {
      if (values.includes("no QR")) hideFlag = hideFlagQR;
      if (values.includes("exist QR")) hideFlag = hideFlagQRexist;
    }
  } else {
    hideFlag = true;
    if (values.includes("COMP")) hideFlag &&= hideFlagComp;
    if (values.includes("1 left")) hideFlag &&= hideFlag1Left;
    if (values.includes("2 left")) hideFlag &&= hideFlag2Left;
    if (values.includes("3 left")) hideFlag &&= hideFlag3Left;
    if (values.includes("4 left")) hideFlag &&= hideFlag4Left;
    if (values.includes("don't have")) hideFlag &&= hideFlagDontHave;
  }
  return hideFlag;
};
